import { useInfiniteQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { FetchCampaigns, type CampaignListRequest } from '../api/fetch-campaign-list';

type InfiniteCampaignListRequest = Omit<CampaignListRequest, 'page'>;

export function useCampaigns(request: InfiniteCampaignListRequest) {
  const { workspaceId } = useWorkspaceId();
  const queryKeys = useQueryKeys();

  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: queryKeys.campaign.infiniteLists(request),
    queryFn: ({ pageParam, signal }) =>
      FetchCampaigns(workspaceId, { ...request, page: pageParam }, signal),
    getNextPageParam: (lastPage) => {
      const { page, limit, total } = lastPage.pagination;

      if (page * limit >= total) return undefined;
      return page + 1;
    },
    staleTime: 30_000,
  });
}
